import api from "./api";

const withIdempotency = () => ({
  headers: { "Idempotency-Key": `receipt-${Date.now()}-${Math.random().toString(16).slice(2)}` },
});

const pendingKey = "herrametal.pending-receipt.v1";
const readPending = () => {
  const value = sessionStorage.getItem(pendingKey);
  return value ? JSON.parse(value) : null;
};
const randomKey = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return `receipt-${Array.from(bytes, x => x.toString(16).padStart(2, "0")).join("")}`;
};
const sendPending = async (pending) => {
  try {
    const response = await api.post("/receipts", pending.payload, { headers: { "Idempotency-Key": pending.key } });
    sessionStorage.removeItem(pendingKey);
    return response;
  } catch (error) {
    // A validation response proves the endpoint rejected the request before
    // starting the receipt. Other failures can happen after commit.
    if (error.response?.status === 400 && !pending.uncertain) sessionStorage.removeItem(pendingKey);
    else { pending.uncertain = true; sessionStorage.setItem(pendingKey, JSON.stringify(pending)); }
    throw error;
  }
};

export const receiptsService = {
  list(params) {
    return api.get("/receipts", { params });
  },
  get(id) {
    return api.get(`/receipts/${id}`);
  },
  async create(payload) {
    let pending = readPending();
    if (pending && JSON.stringify(pending.payload) !== JSON.stringify(payload)) throw new Error("Hay un cobro sin confirmar. Recuperalo antes de registrar otro.");
    if (!pending) {
      pending = { key: randomKey(), payload, uncertain: false };
      sessionStorage.setItem(pendingKey, JSON.stringify(pending));
    }
    return sendPending(pending);
  },
  pendingCreate() { return readPending(); },
  retryPendingCreate() {
    const pending = readPending();
    if (!pending) throw new Error("No hay un cobro pendiente de recuperar.");
    return sendPending(pending);
  },
  cancel(id, reason) {
    return api.post(`/receipts/${id}/cancel`, { reason }, withIdempotency());
  },
  linkInvoice(id, payload) {
    return api.post(`/receipts/${id}/link-invoice`, payload, withIdempotency());
  },
  uploadAttachment(id, file) {
    const form = new FormData(); form.append("attachment", file);
    return api.post(`/receipts/${id}/attachment`, form, { timeout: 60000 });
  },
  downloadAttachment(id) { return api.get(`/receipts/${id}/attachment`, { responseType: "blob" }); },
  downloadPdf(id) {
    return api.get(`/receipts/${id}/pdf`, { responseType: "blob" });
  },
};
